import React, { Component } from 'react'
import { connect } from 'react-redux'

import Home from 'form/templates/Home'
import { CMS_LOADED } from 'form/store/page/constants'
import * as pageActions from 'form/store/page/actions'

import {
  IntegratorRoot,
  ThemeProvider
} from '@volkswagen-onehub/components-core'

import './App.css'

class App extends Component {
  cmsDataHasLoaded = e => {
    const { setPageStatus } = this.props
    setPageStatus(CMS_LOADED)
  }

  loadScript = (src, waitForLoaded) => {
    var tag = document.createElement('script')
    tag.async = false
    tag.src = process.env.PUBLIC_URL + window.reactBasePath + src
    if (waitForLoaded) {
      tag.addEventListener('load', this.cmsDataHasLoaded)
    }
    document.getElementsByTagName('body')[0].appendChild(tag)
  }

  componentDidMount() {
    this.loadScript('/js/jahia-config.js', true)
    this.loadScript('/js/data-tracking.js', false)
  }

  render() {
    const { status } = this.props
    return (
      <IntegratorRoot>
        <ThemeProvider>{status === CMS_LOADED && <Home />}</ThemeProvider>
      </IntegratorRoot>
    )
  }
}

const mapStateToProps = ({ page }) => {
  const { status } = page

  return {
    status
  }
}
export default connect(mapStateToProps, pageActions)(App)
